/* unplugin-vue-components disabled */import script from "./flowRecord.vue?vue&type=script&setup=true&lang=js"
export * from "./flowRecord.vue?vue&type=script&setup=true&lang=js"

import "./flowRecord.vue?vue&type=style&index=0&id=3766970f&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3766970f"]])

export default __exports__